/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 3.9392C0 2.8682.8746 2 1.9535 2h20.093C23.1254 2 24 2.8682 24 3.9392v4.4324c0 1.071-.8746 1.9392-1.9535 1.9392H1.9535C.8746 10.3108 0 9.4426 0 8.3716V3.9392Zm1.9535-.277a.278.278 0 0 0-.279.277v4.4324c0 .153.1249.277.279.277h20.093a.2781.2781 0 0 0 .2791-.277V3.9392c0-.153-.125-.277-.2791-.277H1.9535Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M7.8139 14.3311c0-.459.3748-.8311.8372-.8311h6.6977c.4624 0 .8372.3721.8372.8311 0 .459-.3748.8311-.8372.8311H8.6511c-.4624 0-.8372-.3721-.8372-.8311Z"
    />
    <path
      fill="currentColor"
      d="M3.907 12.0311c0-.459-.3749-.8311-.8373-.8311-.4623 0-.8372.3721-.8372.8311v8.8648c0 1.071.8746 1.9392 1.9535 1.9392H19.814c1.0789 0 1.9535-.8682 1.9535-1.9392v-8.8648c0-.459-.3748-.8311-.8372-.8311-.4624 0-.8372.3721-.8372.8311v8.8648a.278.278 0 0 1-.2791.2771H4.186a.2781.2781 0 0 1-.279-.2771v-8.8648Z"
    />
  </React.Fragment>,
  'Archive'
);
